import React from "react";

export const Callisto = () => {
  return (
    <div>
      <div
        id={"callisto"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};
